import { hashCode } from '@/mixins/utils'
import { cloneDeep } from 'lodash'

const logger = require('debug')('careship:class/FamilyMember')

export interface FamilyMemberData {
  salutation: string
  name: {
    first_name: string
    last_name: string
  }
  relationship: string
}

export interface FamilyMemberCleanPropData {
  salutation: string
  firstName: string
  lastName: string
  relationship: string
}

class FamilyMember {
  salutation: string

  firstName: string

  lastName: string

  relationship: string

  customerId?: string

  careReceiverId?: string

  constructor(props: FamilyMemberData | FamilyMemberCleanPropData) {
    this.salutation = props.salutation || ''
    this.firstName = 'name' in props ? props.name.first_name : props.firstName
    this.lastName = 'name' in props ? props.name.last_name : props.lastName
    this.relationship = props.relationship
    logger('new FamilyMember from props %O -> %O', props, this)
  }

  isAccountHolder() {
    return this.relationship === 'You' || this.relationship === 'Ich selbst'
  }

  getFullName() {
    return `${this.salutation} ${this.firstName} ${this.lastName}`
  }

  getInitials() {
    return this.firstName.substring(0, 1) + this.lastName.substring(0, 1)
  }

  isCareReceiver() {
    return 'careReceiverId' in this
  }

  get isCustomer() {
    return 'customerId' in this
  }

  isSelfBooker() {
    return this.isCareReceiver() && this.isCustomer
  }

  get id() {
    return this.isCareReceiver() ? this.careReceiverId : this.customerId
  }

  // @TODO: add test spec for username
  get username() {
    return hashCode(this.id).toString()
  }

  getViewModel() {
    return cloneDeep(this)
  }
}

export default FamilyMember
